import { render } from "./DocumentNavigation.vue?vue&type=template&id=b7f85130&scoped=true"
import script from "./DocumentNavigation.vue?vue&type=script&lang=js"
export * from "./DocumentNavigation.vue?vue&type=script&lang=js"

import "./DocumentNavigation.vue?vue&type=style&index=0&id=b7f85130&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7f85130"]])

export default __exports__